import { API } from "../api";
import { setError } from "./Indicator";
import { CUSTOMS_ORDER_LIST } from "../constants/url.constant";

export const REQUEST_CUSTOMS_SHIPING_LIST = "REQUEST_CUSTOMS_SHIPING_LIST";
export const SET_CUSTOMS_SHIPING_LIST = "SET_CUSTOMS_SHIPING_LIST";

export const setCustomsShipingList = (data) => {
  return {
    type: SET_CUSTOMS_SHIPING_LIST,
    payload: data
  };
};

export const customsShipingList = ({ limit, page }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMS_SHIPING_LIST });
    try {
      const res = await API.get(`${CUSTOMS_ORDER_LIST}`, {
        params: {
          limit: limit,
          page: page,
          accountType: "INT"
        }
      });

      return dispatch(setCustomsShipingList(res));
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  data: [],
  totalRows: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_CUSTOMS_SHIPING_LIST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_CUSTOMS_SHIPING_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
